export default __webpack_public_path__ + "static/media/background.f2abe5be.svg";